import { render, staticRenderFns } from "./PublicationSearch.vue?vue&type=template&id=19fd8824&scoped=true"
import script from "./PublicationSearch.vue?vue&type=script&lang=js"
export * from "./PublicationSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd8824",
  null
  
)

export default component.exports